export const SET_USERS = "SET_USERS";
export const SET_LOADING_STATUS = "SET_LOADING_STATUS";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
